<div class="surface-card p-4 border-round">

  <!-- ================= HEADER ================= -->
  <div class="flex align-items-center gap-2 mb-2 text-sm">
    <span class="text-primary text-xl font-medium cursor-pointer underline">
      Customer Lookup
    </span>

    <span class="text-500">/</span>

    <span class="font-semibold text-900">
      {{ customer.firstName }} {{ customer.lastName }}
    </span>

    <span
      class="border-1 border-primary text-primary border-round-xl
            px-2 py-1 text-xs font-medium ml-1"
    >
      Customer
    </span>
  </div>

  <!-- Divider -->
  <div class="w-full border-top-1 surface-border mb-4"></div>
  
  <!-- TABS HEADER -->
  <p-tabView class="mb-4" [(activeIndex)]="activeTab">

    <p-tabPanel header="Customer Details" class="text-primary">
      <ng-template pTemplate="header">
          <span [ngClass]="activeTab === 0 ? 'text-primary font-semibold' : 'text-500'">Customer Details</span> 
      </ng-template>  

      <!-- Tab 1 Content -->
      <div class="p-3">
        <div class="w-full sm:w-10 md:w-8 lg:w-6 xl:w-5 justify-content-center mx-auto">

          <form [formGroup]="customerDetailsForm">

            <!-- ================= BUSINESS NAME ================= -->
            <div class="grid mb-3">
              <div class="col-12 md:col-6 field">
                <label for="businessName" class="block text-xs font-semibold mb-1">
                  Business Name
                </label>
                <input
                  id="businessName"
                  pInputText
                  formControlName="businessName"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 0)"
                  [class.text-700]="!(isEditMode && editTabIndex === 0)"
                />
              </div>
              <div class="hidden md:block md:col-6"></div>
            </div>

            <!-- ================= FIRST / LAST NAME ================= -->
            <div class="grid mb-3">
              <div class="col-12 md:col-6 field">
                <label for="firstName" class="block text-xs font-semibold mb-1">
                  First Name
                </label>
                <input
                  id="firstName"
                  pInputText
                  formControlName="firstName"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 0)"
                  [class.text-700]="!(isEditMode && editTabIndex === 0)"
                />
              </div>

              <div class="col-12 md:col-6 field">
                <label for="lastName" class="block text-xs font-semibold mb-1">
                  Last Name
                </label>
                <input
                  id="lastName"
                  pInputText
                  formControlName="lastName"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 0)"
                  [class.text-700]="!(isEditMode && editTabIndex === 0)"
                />
              </div>
            </div>

            <!-- ================= PHONES ================= -->
            <div class="grid mb-3">
              <div class="col-12 md:col-6 field">
                <label class="block text-xs font-semibold mb-1" for="primaryPhone">
                  Primary Phone
                </label>
                <input
                  id="primaryPhone"
                  pInputText
                  formControlName="primaryPhone"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 0)"
                  [class.text-700]="!(isEditMode && editTabIndex === 0)"
                />
              </div>

              <div class="col-12 md:col-6 field">
                <label for="secondaryPhone" class="block text-xs font-semibold mb-1">
                  Secondary Phone
                </label>
                <input
                  id="secondaryPhone"
                  pInputText
                  formControlName="secondaryPhone"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 0)"
                  [class.text-700]="!(isEditMode && editTabIndex === 0)"
                />
              </div>
            </div>

            <!-- ================= EMAIL ================= -->
            <div class="grid mb-4">
              <div class="col-12 md:col-6 field">
                <label for="email" class="block text-xs font-semibold mb-1">
                  Email Address
                </label>
                <input
                  id="email"
                  pInputText
                  formControlName="email"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 0)"
                  [class.text-700]="!(isEditMode && editTabIndex === 0)"
                />
              </div>
              <div class="hidden md:block md:col-6"></div>
            </div>

            <div class="w-full border-top-2 surface-border my-2"></div>

            <!-- ================= ADDRESS ================= -->
            <div class="grid mb-3">
              <div class="col-12 field">
                <label for="street" class="block text-xs font-semibold mb-1">
                  Street Address
                </label>
                <input
                  id="street"
                  pInputText
                  formControlName="street"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 0)"
                  [class.text-700]="!(isEditMode && editTabIndex === 0)"
                />
              </div>
            </div>

            <div class="grid mb-3">
              <div class="col-12 md:col-6 field">
                <label for="city" class="block text-xs font-semibold mb-1">
                  City
                </label>
                <input
                  id="city"
                  pInputText
                  formControlName="city"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 0)"
                  [class.text-700]="!(isEditMode && editTabIndex === 0)"
                />
              </div>

              <div class="col-12 md:col-6 field">
                <label for="state" class="block text-xs font-semibold mb-1">
                  State
                </label>
                <input
                  id="state"
                  pInputText
                  formControlName="state"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 0)"
                  [class.text-700]="!(isEditMode && editTabIndex === 0)"
                />
              </div>
            </div>

            <div class="grid mb-3">
              <div class="col-12 md:col-6 field">
                <label for="zip" class="block text-xs font-semibold mb-1">
                  Zip Code
                </label>
                <input
                  id="zip"
                  pInputText
                  formControlName="zip"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 0)"
                  [class.text-700]="!(isEditMode && editTabIndex === 0)"
                />
              </div>
              <div class="hidden md:block md:col-6"></div>
            </div>

            <!-- ================= ACTION BUTTONS ================= -->
            <div class="flex justify-content-end mt-4 gap-3">

              <!-- EDIT -->
              <button
                *ngIf="!isEditMode"
                pButton
                type="button"
                class="p-button-link text-primary text-sm font-medium"
                (click)="onEdit(0)"
              >
                <i class="pi pi-pencil mr-2"></i>
                Edit customer details
              </button>

              <!-- CANCEL -->
              <button
                *ngIf="isEditMode && editTabIndex === 0"
                pButton
                type="button"
                class="p-button-text"
                (click)="onCancelClick()"
              >
                Cancel Edit
              </button>
              <button
                *ngIf="isEditMode && editTabIndex === 0"
                pButton
                type="button"
                class="p-button-primary"
                [disabled]="!customerDetailsForm.dirty"
                (click)="onSave()"
              >
                Save
              </button>

            </div>

          </form>
        </div>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Billing Details" class="text-primary">
       <ng-template pTemplate="header">
          <span [ngClass]="activeTab === 1 ? 'text-primary font-semibold' : 'text-500'">Billing Details</span> 
      </ng-template>  
      <!-- Tab 2 Content -->
       <div class="w-full sm:w-10 md:w-8 lg:w-6 xl:w-5 justify-content-center mx-auto "> 
           <form [formGroup]="billingDetailsForm">
            <!-- ================= FIRST / LAST NAME ================= -->
            <div class="grid mb-3">
              <div class="col-12 md:col-6 field">
                <label for="firstName" class="block text-xs font-semibold mb-1">
                  First Name
                </label>
                <input
                  id="firstName"
                  pInputText
                  formControlName="firstName"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 1)"
                  [class.text-700]="!(isEditMode && editTabIndex === 1)"
                />
              </div>

              <div class="col-12 md:col-6 field">
                <label for="lastName" class="block text-xs font-semibold mb-1">
                  Last Name
                </label>
                <input
                  id="lastName"
                  pInputText
                  formControlName="lastName"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 1)"
                  [class.text-700]="!(isEditMode && editTabIndex === 1)"
                />
              </div>
            </div>

            <!-- ================= PHONES ================= -->
            <div class="grid mb-3">
              <div class="col-12 md:col-6 field">
                <label class="block text-xs font-semibold mb-1" for="primaryPhone">
                  Primary Phone
                </label>
                <input
                  id="primaryPhone"
                  pInputText
                  formControlName="primaryPhone"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 1)"
                  [class.text-700]="!(isEditMode && editTabIndex === 1)"
                />
              </div>

              <div class="col-12 md:col-6 field">
                <label for="email" class="block text-xs font-semibold mb-1">
                  Email Address
                </label>
                <input
                  id="email"
                  pInputText
                  formControlName="email"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 1)"
                  [class.text-700]="!(isEditMode && editTabIndex === 1)"
                />
              </div>
            </div>
            
            <div class="w-full border-top-2 surface-border my-2"></div>

            <!-- ================= ADDRESS ================= -->
            <div class="grid mb-3">
              <div class="col-12 field">
                <label for="street" class="block text-xs font-semibold mb-1">
                  Street Address
                </label>
                <input
                  id="street"
                  pInputText
                  formControlName="street"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 1)"
                  [class.text-700]="!(isEditMode && editTabIndex === 1)"
                />
              </div>
            </div>

            <div class="grid mb-3">
              <div class="col-12 md:col-6 field">
                <label for="city" class="block text-xs font-semibold mb-1">
                  City
                </label>
                <input
                  id="city"
                  pInputText
                  formControlName="city"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 1)"
                  [class.text-700]="!(isEditMode && editTabIndex === 1)"
                />
              </div>

              <div class="col-12 md:col-6 field">
                <label for="state" class="block text-xs font-semibold mb-1">
                  State
                </label>
                <input
                  id="state"
                  pInputText
                  formControlName="state"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 1)"
                  [class.text-700]="!(isEditMode && editTabIndex === 1)"
                />
              </div>
            </div>

            <div class="grid mb-3">
              <div class="col-12 md:col-6 field">
                <label for="zip" class="block text-xs font-semibold mb-1">
                  Zip Code
                </label>
                <input
                  id="zip"
                  pInputText
                  formControlName="zip"
                  class="w-full surface-300 text-700"
                  [class.surface-300]="!(isEditMode && editTabIndex === 1)"
                  [class.text-700]="!(isEditMode && editTabIndex === 1)"
                />
              </div>
              <div class="hidden md:block md:col-6"></div>
            </div>

            <!-- ================= ACTION BUTTONS ================= -->
            <div class="flex justify-content-end mt-4 gap-3">

              <!-- EDIT -->
              <button
                *ngIf="!isEditMode"
                pButton
                type="button"
                class="p-button-link text-primary text-sm font-medium"
                (click)="onEdit(1)"
              >
                <i class="pi pi-pencil mr-2"></i>
                Edit customer details
              </button>

              <!-- CANCEL -->
              <button
                *ngIf="isEditMode && editTabIndex === 1"
                pButton
                type="button"
                class="p-button-text"
                (click)="onCancelClick()"
              >
                Cancel Edit
              </button>
              <button
                *ngIf="isEditMode && editTabIndex === 1"
                pButton
                type="button"
                class="p-button-primary"
                [disabled]="!billingDetailsForm.dirty"
                (click)="onSave()"
              >
                Save
              </button>

            </div>

          </form>

       </div>
          
      
    </p-tabPanel>

    <p-tabPanel header="Shipping Details" class="text-primary">
      <ng-template pTemplate="header">
          <span [ngClass]="activeTab === 2 ? 'text-primary font-semibold' : 'text-500'">Shipping Details</span> 
      </ng-template>  
      <!-- Tab 3 Content -->
      <div class="p-3">
        <div class="w-full sm:w-10 md:w-8 lg:w-6 xl:w-5 justify-content-center mx-auto "> 
          <form [formGroup]="shippingDetailsForm">
            <!-- ================= FIRST / LAST NAME ================= -->
            <div class="grid mb-3">
              <div class="col-12 md:col-6 field">
                <label for="firstName" class="block text-xs font-semibold mb-1">
                  First Name
                </label>
                <input
                  id="firstName"
                  pInputText
                  formControlName="firstName"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 2)"
                  [class.text-700]="!(isEditMode && editTabIndex === 2)"
                />
              </div>

              <div class="col-12 md:col-6 field">
                <label for="lastName" class="block text-xs font-semibold mb-1">
                  Last Name
                </label>
                <input
                  id="lastName"
                  pInputText
                  formControlName="lastName"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 2)"
                  [class.text-700]="!(isEditMode && editTabIndex === 2)"
                />
              </div>
            </div>

            <!-- ================= PHONES ================= -->
            <div class="grid mb-3">
              <div class="col-12 md:col-6 field">
                <label class="block text-xs font-semibold mb-1" for="primaryPhone">
                  Primary Phone
                </label>
                <input
                  id="primaryPhone"
                  pInputText
                  formControlName="primaryPhone"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 2)"
                  [class.text-700]="!(isEditMode && editTabIndex === 2)"
                />
              </div>

              <div class="col-12 md:col-6 field">
                <label for="email" class="block text-xs font-semibold mb-1">
                  Email Address
                </label>
                <input
                  id="email"
                  pInputText
                  formControlName="email"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 2)"
                  [class.text-700]="!(isEditMode && editTabIndex === 2)"
                />
              </div>
            </div>
            
            <div class="w-full border-top-2 surface-border my-2"></div>

            <!-- ================= ADDRESS ================= -->
            <div class="grid mb-3">
              <div class="col-12 field">
                <label for="street" class="block text-xs font-semibold mb-1">
                  Street Address
                </label>
                <input
                  id="street"
                  pInputText
                  formControlName="street"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 2)"
                  [class.text-700]="!(isEditMode && editTabIndex === 2)"
                />
              </div>
            </div>

            <div class="grid mb-3">
              <div class="col-12 md:col-6 field">
                <label for="city" class="block text-xs font-semibold mb-1">
                  City
                </label>
                <input
                  id="city"
                  pInputText
                  formControlName="city"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 2)"
                  [class.text-700]="!(isEditMode && editTabIndex === 2)"
                />
              </div>

              <div class="col-12 md:col-6 field">
                <label for="state" class="block text-xs font-semibold mb-1">
                  State
                </label>
                <input
                  id="state"
                  pInputText
                  formControlName="state"
                  class="w-full"
                  [class.surface-300]="!(isEditMode && editTabIndex === 2)"
                  [class.text-700]="!(isEditMode && editTabIndex === 2)"
                />
              </div>
            </div>

            <div class="grid mb-3">
              <div class="col-12 md:col-6 field">
                <label for="zip" class="block text-xs font-semibold mb-1">
                  Zip Code
                </label>
                <input
                  id="zip"
                  pInputText
                  formControlName="zip"
                  class="w-full surface-300 text-700"
                  [class.surface-300]="!(isEditMode && editTabIndex === 2)"
                  [class.text-700]="!(isEditMode && editTabIndex === 2)"
                />
              </div>
              <div class="hidden md:block md:col-6"></div>
            </div>

            <!-- ================= ACTION BUTTONS ================= -->
            <div class="flex justify-content-end mt-4 gap-3">

              <!-- EDIT -->
              <button
                *ngIf="!isEditMode"
                pButton
                type="button"
                class="p-button-link text-primary text-sm font-medium"
                (click)="onEdit(2)"
              >
                <i class="pi pi-pencil mr-2"></i>
                Edit customer details
              </button>

               <!-- CANCEL -->
              <button
                *ngIf="isEditMode && editTabIndex === 2"
                pButton
                type="button"
                class="p-button-text"
                (click)="onCancelClick()"
              >
                Cancel Edit
              </button>
              <button
                *ngIf="isEditMode && editTabIndex === 2"
                pButton
                type="button"
                class="p-button-primary"
                [disabled]="!shippingDetailsForm.dirty"
                (click)="onSave()"
              >
                Save
              </button>

            </div>

          </form>
        </div>  
      </div>
    </p-tabPanel>

  </p-tabView>

  

  <!-- BOTTOM TABS -->
  <p-tabView class="mt-4">
    <p-tabPanel header="Products"></p-tabPanel>
    <p-tabPanel header="Orders"></p-tabPanel>
    <p-tabPanel header="Installations"></p-tabPanel>
    <p-tabPanel header="Documents"></p-tabPanel>
  </p-tabView>

</div>

<p-confirmDialog
  key="saveConfirm"
  [style]="{ width: '420px' }"
  [closable]="true"
  [dismissableMask]="true"
  styleClass="border-round-xl"
>

  <!-- HEADER -->
  <ng-template pTemplate="header">
    <div class="flex justify-content-between align-items-center w-full">
      <span class="text-lg font-semibold">Save changes?</span>
      <i
        class="pi pi-times text-500 cursor-pointer"
        (click)="confirmationService.close()"
      ></i>
    </div>
  </ng-template>

  <!-- MESSAGE -->
  <ng-template pTemplate="message">
    <p class="text-600 text-sm line-height-3 mt-3">
      You have updated information on this page. Do you want to save?
    </p>
  </ng-template>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <div class="flex justify-content-between align-items-center w-full">
      <button
        pButton
        type="button"
        class="p-button-text flex align-items-center gap-2"
        (click)="onRejectConfirm()"
      >
        <i class="pi pi-trash text-red-600"></i>
        <span>Do not save</span>
      </button>

      <button
        pButton
        type="button"
        class="p-button-primary font-semibold px-4 py-2 border-round-lg"
        (click)="onAcceptConfirm()"
      >
        SAVE CHANGES
      </button>
    </div>
  </ng-template>
</p-confirmDialog>